/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, July 2022
 * @format
 * @flow
 */

import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import PopupHeader from '../PopupHeader';
import Button from '../Button';
import { CountryPicker, getPickerData } from '../CountryPicker';
import FireboardUtils from "../../util/fireboard-util";
import classes from "./SmsReceipt.module.css";

const US_COUNTRY_CODE = 'us';
const UK_COUNTRY_CODE = 'gb';

const TextReceipt = ({
  onClose,
  currency,
  defaultPhoneNumber,
  defaultCountryCode,
  onSubmit,
}) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCountry, setSelectedCountry] = useState({});
  const [error, setError] = useState('');

  useEffect(() => {
    setPhoneNumber(defaultPhoneNumber || "");
    setDefaultCountry();
  }, []);

  const setDefaultCountry = () => {
    const countriesData = getPickerData();
    let defaultCountry = {};
    if (defaultCountryCode) {
      defaultCountry = countriesData.find(country => country.dialCode.split('+')[1] === defaultCountryCode);
    } else {
      const countryCode = currency === '£' ? UK_COUNTRY_CODE : US_COUNTRY_CODE;
      defaultCountry = countriesData.find(country => country.iso2 === countryCode);
    }
    setSelectedCountry(defaultCountry);
  };

  const onCountryChange = country => {
    const formattedPhoneNumber = FireboardUtils.inputFormattedPhnNum(phoneNumber, country.iso2);
    setSelectedCountry(country);
    setPhoneNumber(formattedPhoneNumber);
  };

  const onDone = () => {
    if (validateNumber()) {
      onSubmit && onSubmit({
        phoneNumber: phoneNumber,
        selectedCountry: selectedCountry,
      });
    } else {
      setError('Please enter valid phone number');
    }
  };

  const validateNumber = () => {
    const unformattedPhnNum = FireboardUtils.inputUnFormattedPhnNum(phoneNumber, selectedCountry?.iso2);
    if (unformattedPhnNum.length < 10)
      return false;
    return true;
  };

  return (
    <div className={classes.container}>
      <PopupHeader onClose={onClose} />
      <div className={classes.wrapper}>
        <span className={classes.label}>Please enter your phone number</span>
        <div>
          <CountryPicker
            selectedCountry={selectedCountry}
            onCountryChange={onCountryChange}
            containerStyle={classes.countryPicker} />
        </div>
        <input
          type="tel"
          placeholder="Phone Number"
          value={FireboardUtils.inputFormattedPhnNum(phoneNumber, selectedCountry.iso2)}
          onChange={e => setPhoneNumber(e.target.value)}
          className={classes.input}
        />
        <span className={classes.errorTxt}>{error}</span>
        <Button
          className={classes.button}
          onClick={onDone}
        >
          <span className={classes.text}>DONE</span>
        </Button>
      </div>
    </div>
  );
};

export default TextReceipt;

TextReceipt.propTypes = {
  onClose: PropTypes.func,
  currency: PropTypes.string,
  defaultPhoneNumber: PropTypes.string,
  defaultCountryCode: PropTypes.string,
  onSubmit: PropTypes.func,
};

TextReceipt.defaultProps = {
  onClose: () => { },
  currency: '$',
  defaultPhoneNumber: '',
  defaultCountryCode: '',
  onSubmit: () => { },
};
